;(function() {

	function getCurrentTime() {
		return new Date().getTime();
	}

	/**
	 * Set requestAnimationFrame 
	 */
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] 
        							|| window[vendors[x]+'CancelRequestAnimationFrame'];
    }
 
    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = getCurrentTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); }, 
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };
 
    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };

	/**
	 * Ani JS
	 */
    if (!window.Ani)
    	window.Ani = function() {
    		var animations = {},
    		numAnimations = 0,

    		raf = window.requestAnimationFrame,
    		caf = window.cancelAnimationFrame,

    		stopAnimation = function(name) {
    			if(animations[name]) {
					if(animations[name].raf) {
						caf( animations[name].raf );
					}
					numAnimations--;
					delete animations[name];
				}
    		},

    		registerStartAnimation = function(name) {
				if(animations[name]) {
					stopAnimation(name);
				}
				if(!animations[name]) {
					numAnimations++;
					animations[name] = {};
				}
			},

			stopAllAnimations = function() {
				for (var prop in animations) {
					if( animations.hasOwnProperty( prop ) ) {
						stopAnimation(prop);
					} 
				}
			},

			animateProp = function(name, startProp, endProp, duration, easingFn, onUpdate, onComplete) {
				var startAnimTime = getCurrentTime(), t, now = {};

				registerStartAnimation(name);
				 
				var animloop = function() {

					if ( animations[name] ) {
						t = getCurrentTime() - startAnimTime;

						if ( t >= duration ) {
							stopAnimation(name);

							if (onUpdate) {
								onUpdate(endProp, duration)
							}

							if(onComplete) {
								onComplete(endProp);
							}
							return;
						}


						for (var key in endProp) {
						    if (endProp.hasOwnProperty(key)) {
						       now[key] =  (endProp[key] - startProp[key]) * easingFn(t/duration) + startProp[key];
						    }
						}
	
						if (onUpdate) {
							onUpdate(now, t)
						}

						animations[name].raf = raf(animloop);
					}
				};

				animloop();
			};

			return {
				play: animateProp,
				stop: stopAnimation,
				stopAll: stopAllAnimations
			}

    	};


    	window.ani = Ani();

}());